
import React, { useEffect } from 'react';
import CampClosed from './CampClosed/CampClosed';
import { initFacebookPixel } from './facebookPixel';

function App() {
  useEffect(() => {
    initFacebookPixel(); // Initialize Facebook Pixel on app load
  }, []);

  return <CampClosed />;
}

export default App;
